import { atom } from "recoil";

export const maltiParameterState = atom({
  key: "maltiParameterState",
  default: [],
});
